<template>
  <span class="euroAmount">
    <span class="accessibleAmount">{{ formatPrice(amount) }}</span>
    <span class="currency" aria-hidden="true">€</span>
    <span class="whole" aria-hidden="true">{{ parts[0] }}</span>
    <span class="cents" aria-hidden="true">{{ parts[1] }}</span>
  </span>
</template>

<script lang="ts">
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import BasicComponent from '@/global/BasicComponent';

@Component
export default class EuroAmount extends BasicComponent {
  @Prop({type: Number, required: true}) readonly amount!: number;

  get parts(): string[] {
    return this.amount.toFixed(2).split('.');
  }
}
</script>

<style scoped lang="scss">

.euroAmount {
  display: inline-flex;
  align-items: flex-start;
  white-space: nowrap;
  line-height: 1;

  .currency, .cents {
    font-size: .5em;
    line-height: 1.2;
    padding-top: .08em;
  }

  .currency {

    margin-right: .12em;

  }
  .cents {
    margin-left: .08em;
  }
  .accessibleAmount {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip-path: inset(50%);
    white-space: nowrap;
    border: 0;
  }
}
</style>
